import replace from 'lodash/replace';
import { urlMatcher } from '../libs/text';

const url = value => replace(value, urlMatcher, e => `<a target="_blank" href="${e}">${e}</a>`);

export default url;
